import { mapGetters } from "vuex";
import Alerts from "@/components/alerts.vue";
import MainModal from "./components/elements/main-modal.vue";
export default {
  name: "XmedApp",
  components: {
    MainModal,
    Alerts
  },
  computed: {
    ...mapGetters({
      locale: 'trans/locale'
    })
  },
  watch: {
    locale: {
      immediate: true,
      handler: function (locale) {
        if (locale && this.$i18n.locale !== locale) {
          this.$i18n.locale = locale;
        }
      }
    }
  }
};